import React from "react";
import Modal from "react-bootstrap/Modal";
import { BsCalendarWeekFill } from "react-icons/bs";
import ShiftCreation from "../pages/ShiftCreation";

const ShiftCreateUpdateModal = ({ visible, close, shift, updateShift }) => {
  const getTitle = () => {
    if (shift !== null && shift !== undefined) return "Shift Edit";
    return "Add a new shift";
  };

  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsCalendarWeekFill /> {getTitle()}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ShiftCreation
          shift={shift}
          onComplete={(s) => {
            if (updateShift !== null && updateShift !== undefined)
              updateShift(s);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ShiftCreateUpdateModal;
